<p-avatar
  *ngIf="!!label"
  [label]="image ? null : label"
  styleClass="p-mr-2 uppercase"
  [shape]="shape"
  [size]="size ? size : ''"
  [image]="image"
></p-avatar>
